<template>
    <div style="margin: 5px" class="card">
        <div>
            <slot name="top"></slot>
        </div>
        <div @click="toClick">
            <slot name="default">
                <Row type="flex" justify="start">
                    <i-col span="8">
                        <slot name="left">

                        </slot>
                    </i-col>
                    <i-col span="16">
                        <slot name="right">

                        </slot>
                    </i-col>
                </Row>
            </slot>
        </div>
        <div>
            <slot name="bottom"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Wp_card_sku",
        methods:{
            toClick(){
                this.$emit("click")
            }
        }
    }
</script>

<style scoped>
.card{
  border-radius:5px;
}
</style>